import DateFnsUtils from '@date-io/date-fns';
import {
    Backdrop,
    Box, Button, Chip, Drawer, FormControl, Grid, IconButton, InputLabel, makeStyles, MenuItem,
    Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination,
    TableRow, Typography
} from '@material-ui/core';
import GetAppIcon from '@material-ui/icons/GetApp';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import BlockIcon from '@mui/icons-material/Block';
import HistoryIcon from '@mui/icons-material/History';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import TaskAltOutlinedIcon from '@mui/icons-material/TaskAltOutlined';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import Footer from '../../components/Footer/Footer';
import LightTooltip from '../../components/GlobalStyles/LightTooltip';
import StyledCell from '../../components/GlobalStyles/StyledCell';
import StyledTableRow from '../../components/GlobalStyles/StyledTableRow';
import clearIcon from '../../images/buttonIcons/clearIcon.svg';
import header from '../../images/header/header-logo.svg';
import { UserRole } from '../../models/accesscontrol/ClientUserAccessContext';
import { IClosedLetterDetails } from '../../models/Inquiry/LetterDetails/IClosedLetterDetails';
import { IClosedLetterDownloadReason, IClosedLetterRequest } from '../../models/Inquiry/LetterDetails/IClosedLetterRequest';
import { ILetterDetails } from '../../models/Inquiry/LetterDetails/ILetterDetails';
import { useGlobalState } from '../../store/GlobalStore';
import { useFetch, usePost } from '../../utils/apiHelper';
import { PuffLoader } from 'react-spinners';
import ViewPaidLetter from '../../components/Inquiry/LetterDetails/ViewLetterDetails/ViewPaidLetter';
import ViewCreditReportNotMentioned from '../../components/Inquiry/LetterDetails/ViewLetterDetails/ViewCreditReportingNotMentioned';
import ViewCreditReportUpdated from '../../components/Inquiry/LetterDetails/ViewLetterDetails/ViewCreditReportUpdated';
import ViewCreditReportingNotAffected from '../../components/Inquiry/LetterDetails/ViewLetterDetails/ViewCreditReportingNotAffected';
import RejectRequestDrawer from './ClosedLetterRequestActions/RejectRequestDrawer';
import ViewAuditDrawer from './ClosedLetterRequestActions/ViewAuditDrawer';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    container: {
    },
    titleheader: {
        marginTop: '4px'
    },
    Title1: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        marginTop: '10px'
    },
    gridheader: {
        marginTop: '2px',
        borderRadius: '10px',
        backgroundColor: 'white',
        boxShadow: '0px 1px 4px 1px rgba(103, 128, 159, 1)',
        filter: 'drop-shadow(0 -6mm 4mm gray))',
    },
    textField: {
        width: 240,
        alignContent: 'flex-start',
        justify: 'flex-start',
        marginTop: '14px',
        '& .MuiFormControl-marginNormal': {
            marginTop: '10px',
        },
    },
    statusField: {
        width: 240,
        marginTop: '12px',
    },
    statusSelect: {
        fontSize: 14,
        color: 'black',
        paddingTop: 10,
        paddingBottom: 10
    },
    statusMenuItem: {
        fontSize: 14,
        padding: '8px 16px',
    },
    buttons: {
        borderRadius: 20,
        fontSize: '11px',
        background: '#007FFF',
        color: 'white',
        paddingLeft: 8,
        marginTop: '17px',
    },
    ClearFilterButtonStyle: {
        borderRadius: 20,
        fontSize: '11px',
        background: '#007FFF',
        color: 'white',
        marginLeft: '10px',
        paddingLeft: 8,
        marginTop: '17px',
    },
    IconStyle: {
        height: '15px',
        width: '15px',
        marginLeft: '2px',
    },
    tablebody: {
        maxHeight: 500,
        minHeight: 500,
        [theme.breakpoints.up('lg')]: {
            maxHeight: 'calc( 100vh - 220px)',
            minHeight: 'calc( 100vh - 220px)'
        },
    },
    TableCellStyle: {
        background: '#007FFF',
        color: 'white',
        fontSize: 12.5,
        fontWeight: 600,
        letterSpacing: 0.3,
        padding: '10px 10px',
    },
    TableCellStyle1: {
        fontSize: 13,
        padding: '8px 10px',
    },
    outlinedInput: {
        fontSize: 14,
        color: 'black',
    },
    footer: {
        marginTop: '15px',
        float: 'right',
        marginRight: '70px',
    },
    actionPanel: {
        marginTop: 12,
        padding: 14,
        borderRadius: 10,
        boxShadow: '0px 1px 4px 1px rgba(103, 128, 159, 1)',
    },
    letterButtonWrap: {
        marginTop: 12,
    },
    statusChip: {
        fontWeight: 600,
        fontSize: 12,
        height: 24,
    },
    statusChipActive: {
        backgroundColor: '#fff4e5',
        color: '#b26a00',
    },
    statusChipEmailed: {
        backgroundColor: '#e3f2fd',
        color: '#0d47a1',
    },
    statusChipDownloaded: {
        backgroundColor: '#ede7f6',
        color: '#4527a0',
    },
    statusChipRejected: {
        backgroundColor: '#fdecea',
        color: '#b71c1c',
    },
    statusChipMailed: {
        backgroundColor: '#e0f2f1',
        color: '#00695c',
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
    // The ViewXxxLetter components render a bare <VisibilityIcon /> with no size prop, so its
    // IconButton renders larger than the size="small" icons next to it in the Actions row.
    // Scaling the whole subtree down (rather than clipping with overflow: hidden) keeps the
    // icon fully visible and centered instead of cropping it on some rows.
    viewIconScale: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transform: 'scale(0.72)',
        transformOrigin: 'center',
    },
}));

const usePopoverStyles = makeStyles({
    paper: {
        border: '2px solid black',
    },
});

type ClosedLetterRequestFilter = 'all' | 'active' | 'downloaded' | 'emailed' | 'mailed' | 'rejected';

// Contextual help for known download reasons, same pattern as RejectRequestDrawer's reasonHelp.
const downloadReasonHelp: Record<string, string> = {
    'Other': 'Add the specific reason in the comments below.',
};

const ClosedLetterRequests: React.FC = () => {
    const classes = useStyles();
    const popoverClasses = usePopoverStyles();
    const { state } = useGlobalState();
    const [requests, setRequests] = useState<IClosedLetterRequest[]>([]);
    const [selectedRequest, setSelectedRequest] = useState<IClosedLetterRequest | null>(null);
    const [selectedMode, setSelectedMode] = useState<'view' | 'download'>('view');
    const [letterOpenToken, setLetterOpenToken] = useState(0);
    const [filter, setFilter] = useState<ClosedLetterRequestFilter>('all');
    const [startDate, setStartDate] = useState<Date | null>(null);
    const [endDate, setEndDate] = useState<Date | null>(null);
    const [letterDetails, setLetterDetails] = useState<IClosedLetterDetails[]>([]);
    const [debtorLetterDetails, setDebtorLetterDetails] = useState<ILetterDetails[]>([]);
    const [progressBar, setShowProgressBar] = useState(true);
    const [mapped, setMapped] = useState(false);
    const [totalRecords, setTotalRecords] = useState<number>(0);
    const [rowsPerPage, setRowsPerPage] = useState(15);
    const [page, setPage] = useState(0);
    const [pendingDownload, setPendingDownload] = useState(false);

    const [rejectDrawerOpen, setRejectDrawerOpen] = useState(false);
    const [rejectDrawerRequest, setRejectDrawerRequest] = useState<IClosedLetterRequest | null>(null);
    const [auditDrawerOpen, setAuditDrawerOpen] = useState(false);
    const [auditDrawerRequest, setAuditDrawerRequest] = useState<IClosedLetterRequest | null>(null);
    const [downloadConfirmRequest, setDownloadConfirmRequest] = useState<IClosedLetterRequest | null>(null);
    const [downloadReasons, setDownloadReasons] = useState<IClosedLetterDownloadReason[]>([]);
    const [downloadReason, setDownloadReason] = useState('');
    const [downloadComments, setDownloadComments] = useState('');
    const [mailedConfirmRequest, setMailedConfirmRequest] = useState<IClosedLetterRequest | null>(null);
    const [mailedComments, setMailedComments] = useState('');
    const [markingMailed, setMarkingMailed] = useState(false);
    const [emailedConfirmRequest, setEmailedConfirmRequest] = useState<IClosedLetterRequest | null>(null);
    const [emailedComments, setEmailedComments] = useState('');
    const [markingEmailed, setMarkingEmailed] = useState(false);

    const hiddenLetterRef = useRef<HTMLDivElement>(null);
    const downloadMetaRef = useRef<{ letterName: string; debtorNumber: string; clientId: string } | null>(null);

    const canAccessClosedLetterRequests = state.userAccessContext?.role === UserRole.SuperAdmin;
    const dateFormat = state.GlobalUtils?.settingValue === 'DD/MM/YYYY' ? 'dd/MM/yyyy' : state.GlobalUtils?.settingValue === 'YYYY/MM/DD' ? 'yyyy/MM/dd' : 'MM/dd/yyyy';

    // actionTaken is kept only for backward compatibility with any older caller of
    // ClosedLetterRequestsGet; usp_ClosedLetterRequestsGet ignores it once status is supplied.
    const getActionTakenValue = () => {
        if (filter === 'all') return null;
        return filter !== 'active';
    };

    const getStatusFilterValue = () => {
        switch (filter) {
            case 'active': return 'Active';
            case 'downloaded': return 'Downloaded';
            case 'emailed': return 'Emailed';
            case 'mailed': return 'Mailed';
            case 'rejected': return 'Rejected';
            default: return null;
        }
    };

    const loadRequests = async () => {
        setShowProgressBar(true);
        const request = {
            rowsPerPage,
            startingRecordNumber: (page * rowsPerPage) + 1,
            startDate: startDate ? moment(startDate).format('YYYY-MM-DD') : '',
            endDate: endDate ? moment(endDate).format('YYYY-MM-DD') : '',
            actionTaken: getActionTakenValue(),
            requestStatus: getStatusFilterValue(),
        };

        await usePost<{ closedLetterRequests: IClosedLetterRequest[], qty: number }>('ClosedLetterRequestsGet', request).then((response) => {
            setRequests(response.data?.closedLetterRequests || []);
            setTotalRecords(response.data?.qty || 0);
            setMapped(!(response.data?.closedLetterRequests || []).length);
        }).finally(() => {
            setShowProgressBar(false);
        });
    };

    const handleFilter = () => {
        setPage(0);
        loadRequests();
    };

    const handleClearFilter = () => {
        setFilter('active');
        setStartDate(null);
        setEndDate(null);
        setPage(0);
        setSelectedRequest(null);
        setShowProgressBar(true);
    };

    useEffect(() => {
        if (canAccessClosedLetterRequests) {
            loadRequests();
        }
    }, [filter, startDate, endDate, page, rowsPerPage]);

    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
        setShowProgressBar(true);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
        setShowProgressBar(true);
    };

    const openLetter = async (request: IClosedLetterRequest, mode: 'view' | 'download', reason?: string, comments?: string) => {
        let selected = request;

        if (mode === 'download' && !request.isDownloaded) {
            const downloadedByEmail = state.user?.email || state.userAccessContext?.userName || '';
            await usePost('ClosedLetterDownloadedActionUpdate', {
                requestId: request.id,
                downloadedByEmail,
                downloadReason: reason || '',
                downloadComments: comments || '',
            });

            selected = {
                ...request,
                isDownloaded: true,
                requestStatus: 'Downloaded',
                downloadedByEmail,
                downloadedDate: new Date().toISOString(),
                downloadReason: reason,
                downloadComments: comments,
            };

            await loadRequests();
        }

        setSelectedRequest(selected);
        setSelectedMode(mode);

        const detailsResponse = await useFetch<IClosedLetterDetails[]>(`AccountLetterDetailsGet?DBTNumber=${selected.debtorNumber}`);
        const letterResponse = await usePost<{ letterDetails: ILetterDetails[] }>('GetLetterDetails', { debtorId: selected.debtorNumber });
        setLetterDetails(detailsResponse.data || []);
        setDebtorLetterDetails(letterResponse.data?.letterDetails || []);
        setLetterOpenToken((prev) => prev + 1);

        if (mode === 'download') {
            downloadMetaRef.current = {
                letterName: selected.letterName,
                debtorNumber: selected.debtorNumber,
                clientId: selected.clientId,
            };
            setPendingDownload(true);
        }
    };

    // Status reflects the request's lifecycle (Active/Downloaded/Emailed/Mailed/Rejected).
    // Rejected, Emailed, and Mailed are final record-keeping flags - none of them send an email
    // from WebView; they only mark that the letter was emailed or physically mailed outside the
    // app. Downloaded is set once the letter is downloaded and no later flag/Reject action has
    // been taken.
    const getRequestStatusLabel = (request: IClosedLetterRequest) => {
        if (request.requestStatus === 'Rejected' || request.rejectedDate) return 'Rejected';
        if (request.requestStatus === 'Emailed' || request.emailedDate) return 'Emailed';
        if (request.requestStatus === 'Mailed' || request.mailedDate) return 'Mailed';
        if (request.requestStatus === 'Downloaded' || request.isDownloaded) return 'Downloaded';
        return 'Active';
    };

    const getRequestStatusChipClass = (request: IClosedLetterRequest) => {
        const label = getRequestStatusLabel(request);
        if (label === 'Rejected') return classes.statusChipRejected;
        if (label === 'Emailed') return classes.statusChipEmailed;
        if (label === 'Mailed') return classes.statusChipMailed;
        if (label === 'Downloaded') return classes.statusChipDownloaded;
        return classes.statusChipActive;
    };

    // Reject only makes sense while a request is still open: once it has been Downloaded,
    // Emailed, Mailed, or Rejected there is nothing left to reject.
    const canActionRequest = (request: IClosedLetterRequest) => getRequestStatusLabel(request) === 'Active';

    // Mailed and Emailed are both terminal record-keeping flags on the single RequestStatus
    // column (same model as Download/Reject) - a request that has already been Emailed, Mailed,
    // or Rejected is done, so neither option is offered again. Downloaded is not terminal: a
    // downloaded request can still go on to be mailed or emailed.
    const canMarkMailed = (request: IClosedLetterRequest) => {
        const label = getRequestStatusLabel(request);
        return label === 'Active' || label === 'Downloaded';
    };

    const canMarkEmailed = (request: IClosedLetterRequest) => {
        const label = getRequestStatusLabel(request);
        return label === 'Active' || label === 'Downloaded';
    };

    const handleDownloadClick = (request: IClosedLetterRequest) => {
        setDownloadReason('');
        setDownloadComments('');
        setDownloadConfirmRequest(request);
        if (downloadReasons.length === 0) {
            useFetch<IClosedLetterDownloadReason[]>('ClosedLetterDownloadReasonsGet').then((response) => {
                setDownloadReasons(response.data || []);
            });
        }
    };

    const downloadCommentsRequired = downloadReason === 'Other';
    const isDownloadConfirmValid = !!downloadReason && (!downloadCommentsRequired || downloadComments.trim().length > 0);

    const handleConfirmDownload = () => {
        if (downloadConfirmRequest && isDownloadConfirmValid) {
            openLetter(downloadConfirmRequest, 'download', downloadReason, downloadComments);
        }
        setDownloadConfirmRequest(null);
    };

    // Marks a request as Mailed - the admin physically mailed the letter to the requester via
    // USPS, so this is a record-keeping flag only; no email is sent by the app.
    const handleMailedClick = (request: IClosedLetterRequest) => {
        setMailedComments('');
        setMailedConfirmRequest(request);
    };

    const handleConfirmMailed = async () => {
        if (!mailedConfirmRequest) return;
        const mailedByEmail = state.user?.email || state.userAccessContext?.userName || '';

        setMarkingMailed(true);
        try {
            await usePost('ClosedLetterRequestMailed', {
                requestId: mailedConfirmRequest.id,
                mailedByEmail,
                comments: mailedComments,
            });

            setRequests((prev) => prev.map((r) => (
                r.id === mailedConfirmRequest.id
                    ? { ...r, requestStatus: 'Mailed', mailedByEmail, mailedDate: new Date().toISOString(), mailedComments }
                    : r
            )));
            setMailedConfirmRequest(null);
        } finally {
            setMarkingMailed(false);
        }
    };

    // Marks a request as Emailed - the admin emailed the letter to the requester outside WebView
    // (e.g. via Outlook), so this is a record-keeping flag only; no email is sent by the app.
    const handleEmailedClick = (request: IClosedLetterRequest) => {
        setEmailedComments('');
        setEmailedConfirmRequest(request);
    };

    const handleConfirmEmailed = async () => {
        if (!emailedConfirmRequest) return;
        const emailedByEmail = state.user?.email || state.userAccessContext?.userName || '';

        setMarkingEmailed(true);
        try {
            await usePost('ClosedLetterRequestEmailedFlag', {
                requestId: emailedConfirmRequest.id,
                emailedByEmail,
                comments: emailedComments,
            });

            setRequests((prev) => prev.map((r) => (
                r.id === emailedConfirmRequest.id
                    ? { ...r, requestStatus: 'Emailed', emailedByEmail, emailedDate: new Date().toISOString(), emailedComments }
                    : r
            )));
            setEmailedConfirmRequest(null);
        } finally {
            setMarkingEmailed(false);
        }
    };

    const handleOpenAuditDrawer = (request: IClosedLetterRequest) => {
        setAuditDrawerRequest(request);
        setAuditDrawerOpen(true);
    };

    const handleOpenRejectDrawer = (request: IClosedLetterRequest) => {
        setRejectDrawerRequest(request);
        setRejectDrawerOpen(true);
    };

    const handleRejected = (requestId: number, reason: string, comments: string, rejectedByEmail: string) => {
        setRequests((prev) => prev.map((r) => (
            r.id === requestId
                ? { ...r, requestStatus: 'Rejected', rejectReason: reason, rejectComments: comments, rejectedByEmail, rejectedDate: new Date().toISOString() }
                : r
        )));
    };

    useEffect(() => {
        if (!pendingDownload || !hiddenLetterRef.current || !debtorLetterDetails.length) return;

        setPendingDownload(false);
        const el = hiddenLetterRef.current;
        const meta = downloadMetaRef.current;

        html2canvas(el, { scale: 2, useCORS: true, allowTaint: true, windowWidth: 794 }).then((canvas) => {
            const pdf = new jsPDF('p', 'mm', 'a4');
            const pageWidth = pdf.internal.pageSize.getWidth();
            const pageHeight = pdf.internal.pageSize.getHeight();
            const imgWidth = pageWidth;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;
            const imgData = canvas.toDataURL('image/jpeg', 0.95);

            pdf.addImage(imgData, 'JPEG', 0, 0, imgWidth, imgHeight);

            let heightLeft = imgHeight - pageHeight;
            while (heightLeft > 0) {
                pdf.addPage();
                pdf.addImage(imgData, 'JPEG', 0, -(imgHeight - heightLeft), imgWidth, imgHeight);
                heightLeft -= pageHeight;
            }

            const fileName = `${meta?.letterName || 'Letter'}-${meta?.debtorNumber}-${meta?.clientId}.pdf`;
            pdf.save(fileName);
        });
    }, [pendingDownload, debtorLetterDetails]);

    const getLetterBodyText = (letter: ILetterDetails, letterType: string | undefined) => {
        const referralDate = moment(letter?.dbT_REFERRAL_DATE?.split('T')[0]).format(state.GlobalUtils?.settingValue);
        switch (letterType) {
            case 'PaidLetter':
                return `This is to advise you that we have been informed that your account referred on ${referralDate}, referenced above, is now a resolved account. Our records indicate that ${letter?.dbT_NAME?.toUpperCase()}'s account ${letter.dbT_NO} has been satisfied. Your account with us has been updated to reflect this. All collection activity has been stopped. Furthermore, if your credit was affected, this mark will be updated.\n\nShould you have any questions regarding this, please feel free to contact us directly at 888-772-6468.`;
            case 'CreditReportingNotMentionedLetter':
                return `This is to advise you that we have been informed that your account referred on ${referralDate}, referenced above is now a closed account. Your account with us has been updated to reflect this. All collection activity has been stopped.\n\nShould you have any questions regarding this, please feel free to contact us directly at 888-772-6468.`;
            case 'CreditReportUpdated':
                return `This is to advise you that we have been informed that your account referred on ${referralDate}, referenced above is now a closed account. Your account with us has been updated to reflect this. All collection activity has been stopped. Furthermore, if your credit report was affected, this mark will be updated.\n\nShould you have any questions regarding this, please feel free to contact us directly at 888-772-6468.`;
            case 'CreditReportingNotAffectedLetter':
                return `This is to advise you that we have been informed that your account referred on ${referralDate}, referenced above is now a closed account. Your account with us has been updated to reflect this. All collection activity has been stopped. Furthermore, your credit report was not affected by this matter.\n\nShould you have any questions regarding this, please feel free to contact us directly at 888-772-6468.`;
            default:
                return '';
        }
    };

    const getFooterText = (letterType: string | undefined) => {
        if (letterType === 'PaidLetter') {
            return 'California License No.: 10207-99   PO Box 2929, Camarillo, CA 93011';
        }
        return 'PO Box 2929, Camarillo, CA 93011';
    };

    if (!canAccessClosedLetterRequests) {
        return (
            <Box className={classes.container}>
                <Typography variant="h6">Closed Letter Requests</Typography>
                <Typography variant="body1">Only Super Admin users can view closed letter requests.</Typography>
            </Box>
        );
    }

    const hiddenLetter = debtorLetterDetails[0];

    return (
        <React.Fragment>
            <Backdrop className={classes.backdrop} open={progressBar}>
                <PuffLoader size={80} color={"white"} speedMultiplier={1} />
            </Backdrop>

            {/* Hidden off-screen div used to render the letter for PDF capture */}
            <div
                ref={hiddenLetterRef}
                style={{
                    position: 'absolute',
                    left: '-9999px',
                    top: '-9999px',
                    width: '794px',
                    background: 'white',
                    padding: '40px 50px',
                    fontFamily: 'Roboto, Arial, sans-serif',
                    color: '#000',
                    textAlign: 'left',
                    boxSizing: 'border-box',
                }}
            >
                {hiddenLetter && selectedRequest && (
                    <>
                        <div style={{ display: 'block', textAlign: 'left' }}>
                            <img alt="ARM Solutions" src={header} style={{ width: '220px', display: 'block', marginBottom: '8px' }} />
                        </div>
                        <hr style={{ height: '2px', background: 'black', border: 'none', margin: '0 0 12px 0' }} />
                        <p style={{ fontSize: '13px', margin: '10px 0', textAlign: 'left', display: 'block' }}>{moment(new Date()).format('MMMM DD,YYYY')}</p>
                        <p style={{ fontSize: '13px', fontWeight: 'bold', margin: '20px 0 2px', textAlign: 'left', display: 'block' }}>{hiddenLetter?.dbT_NAME?.toUpperCase()}</p>
                        <p style={{ fontSize: '13px', margin: '2px 0', textAlign: 'left', display: 'block' }}>{hiddenLetter?.deM_ADDR1?.toUpperCase()}</p>
                        <p style={{ fontSize: '13px', margin: '2px 0', textAlign: 'left', display: 'block' }}>{hiddenLetter?.deM_CITY?.toUpperCase()}, {hiddenLetter?.deM_STATE?.toUpperCase()} , {hiddenLetter?.deM_ZIP?.toUpperCase()}</p>
                        <p style={{ fontSize: '13px', margin: '30px 0 3px', textAlign: 'left', display: 'block' }}>Client Name: {hiddenLetter?.clT_NAME_1?.toUpperCase()}</p>
                        <p style={{ fontSize: '13px', margin: '3px 0', textAlign: 'left', display: 'block' }}>Client Account Number: {hiddenLetter?.dbT_CLNT_ACNT1?.toUpperCase()}</p>
                        <p style={{ fontSize: '13px', margin: '3px 0', textAlign: 'left', display: 'block' }}>Customer Account Number: {hiddenLetter?.dbT_NO?.toUpperCase()}</p>
                        <p style={{ fontSize: '13px', margin: '40px 0 0', textAlign: 'left', display: 'block' }}>Dear {hiddenLetter?.dbT_NAME?.toUpperCase()},</p>
                        <p style={{ fontSize: '13px', margin: '30px 0 0', whiteSpace: 'pre-line', textAlign: 'left', display: 'block' }}>
                            {getLetterBodyText(hiddenLetter, selectedRequest.letterType)}
                        </p>
                        <p style={{ fontSize: '13px', margin: '30px 0 0', textAlign: 'left', display: 'block' }}>
                            Sincerely,<br />
                            The Customer Service Team<br />
                            A.R.M. Solutions
                        </p>
                        <hr style={{ height: '2px', background: 'black', border: 'none', margin: '30px 0 0' }} />
                        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px', marginTop: '7px', textAlign: 'left' }}>
                            <b>{getFooterText(selectedRequest.letterType)} &nbsp;&nbsp;&nbsp;<span style={{ color: 'red' }}>T</span>  888.772.6468 &nbsp;&nbsp;&nbsp;<span style={{ color: 'red' }}>F</span> 805.830.1104</b>
                            <b style={{ color: 'red' }}>ARMSolutions.com</b>
                        </div>
                    </>
                )}
            </div>

            <Grid container spacing={0}>
                <Grid container xs={12} spacing={0} justify="space-evenly" className={classes.gridheader}>
                    <Grid item xs={3} sm={3} md={3} lg={4} className={classes.Title1} >
                        <Typography variant="h6" gutterBottom className={`${"headertitle"} ${classes.titleheader}`}>
                            <b> CLOSED LETTER REQUESTS</b>
                        </Typography>
                    </Grid>
                    <Grid item xs={6} sm={5} md={3} lg={2}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker
                                size="small"
                                label="Start Date"
                                PopoverProps={{ classes: popoverClasses }}
                                variant="inline"
                                inputVariant="outlined"
                                format={dateFormat}
                                className={classes.textField}
                                disableToolbar
                                autoOk={true}
                                margin="normal"
                                value={startDate}
                                onChange={(date) => setStartDate(date)}
                                KeyboardButtonProps={{ 'aria-label': 'change date' }}
                                InputProps={{ classes: { root: classes.outlinedInput } }}
                                disableFuture={true}
                            />
                        </MuiPickersUtilsProvider>
                    </Grid>
                    <Grid item xs={6} sm={5} md={3} lg={2}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker
                                size="small"
                                label="End Date"
                                PopoverProps={{ classes: popoverClasses }}
                                disableToolbar
                                autoOk={true}
                                inputVariant="outlined"
                                variant="inline"
                                format={dateFormat}
                                className={classes.textField}
                                margin="normal"
                                value={endDate}
                                onChange={(date) => setEndDate(date)}
                                KeyboardButtonProps={{ 'aria-label': 'change date' }}
                                InputProps={{ classes: { root: classes.outlinedInput } }}
                                disableFuture={true}
                            />
                        </MuiPickersUtilsProvider>
                    </Grid>
                    <Grid item xs={6} sm={5} md={3} lg={2}>
                        <FormControl variant="outlined" size="small" className={classes.statusField}>
                            <InputLabel shrink>Status</InputLabel>
                            <Select
                                label="Status"
                                value={filter}
                                onChange={(e: any) => setFilter(e.target.value)}
                                classes={{ select: classes.statusSelect }}
                                MenuProps={{ anchorOrigin: { vertical: 'bottom', horizontal: 'left' }, getContentAnchorEl: null }}
                            >
                                <MenuItem value="active" className={classes.statusMenuItem}>Active</MenuItem>
                                <MenuItem value="downloaded" className={classes.statusMenuItem}>Downloaded</MenuItem>
                                <MenuItem value="emailed" className={classes.statusMenuItem}>Emailed</MenuItem>
                                <MenuItem value="mailed" className={classes.statusMenuItem}>Mailed</MenuItem>
                                <MenuItem value="rejected" className={classes.statusMenuItem}>Rejected</MenuItem>
                                <MenuItem value="all" className={classes.statusMenuItem}>All Requests</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={6} sm={5} md={3} lg={2}>
                        <Button size="small" className={classes.buttons} startIcon={<FilterAltIcon />} onClick={handleFilter} variant="contained" color="primary" disabled={!!startDate && !!endDate && startDate > endDate}>
                            Filter
                        </Button>
                        <Button size="small" className={classes.ClearFilterButtonStyle} startIcon={<img src={clearIcon} alt="Icon for clear filter button" className={classes.IconStyle} />} onClick={handleClearFilter} variant="contained" color="primary">
                            Clear Filter
                        </Button>
                    </Grid>
                    <Grid item xs={12}>
                        <TableContainer component={Paper} className={`${classes.tablebody} ${'scrollbox'} ${'on-scrollbar'}`}>
                            <Table aria-label="closed letter requests" size="small" stickyHeader>
                                <TableHead>
                                    <TableRow>
                                        <TableCell className={classes.TableCellStyle}>Letter</TableCell>
                                        <TableCell className={classes.TableCellStyle}>Requested Date</TableCell>
                                        <TableCell className={classes.TableCellStyle}>Debtor Number</TableCell>
                                        <TableCell className={classes.TableCellStyle}>Client ID</TableCell>
                                        <TableCell className={classes.TableCellStyle}>Client Account</TableCell>
                                        <TableCell className={classes.TableCellStyle}>Requested By</TableCell>
                                        <TableCell className={classes.TableCellStyle}>Reason</TableCell>
                                        <TableCell className={classes.TableCellStyle}>Status</TableCell>
                                        <TableCell className={classes.TableCellStyle} align="center">Mailed</TableCell>
                                        <TableCell className={classes.TableCellStyle}>Actions</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {requests.map((request) => {
                                        const actionable = canActionRequest(request);
                                        const mailable = canMarkMailed(request);
                                        const emailable = canMarkEmailed(request);
                                        const statusLabel = getRequestStatusLabel(request);
                                        return (
                                        <StyledTableRow key={request.id} hover selected={selectedRequest?.id === request.id}>
                                            <StyledCell className={classes.TableCellStyle1}>{request.letterName}</StyledCell>
                                            <StyledCell className={classes.TableCellStyle1}>{moment(request.requestedDate).format(state.GlobalUtils?.settingValue)} {moment(request.requestedDate).format('HH:mm:ss')}</StyledCell>
                                            <StyledCell className={classes.TableCellStyle1}>{request.debtorNumber}</StyledCell>
                                            <StyledCell className={classes.TableCellStyle1}>{request.clientId}</StyledCell>
                                            <StyledCell className={classes.TableCellStyle1}>{request.clientAccountNumber}</StyledCell>
                                            <StyledCell className={classes.TableCellStyle1}>
                                                <LightTooltip title={request.requestedByEmail || ''}>
                                                    <span style={{
                                                        display: 'inline-block', maxWidth: '180px', overflow: 'hidden',
                                                        textOverflow: 'ellipsis', whiteSpace: 'nowrap', verticalAlign: 'bottom',
                                                    }}>
                                                        {request.requestedByEmail}
                                                    </span>
                                                </LightTooltip>
                                            </StyledCell>
                                            <StyledCell className={classes.TableCellStyle1}>
                                                <LightTooltip title={request.rejectComments || request.requestReason || ''}>
                                                    <span style={{
                                                        display: 'inline-block', maxWidth: '180px', overflow: 'hidden',
                                                        textOverflow: 'ellipsis', whiteSpace: 'nowrap', verticalAlign: 'bottom',
                                                    }}>
                                                        {request.requestReason}
                                                    </span>
                                                </LightTooltip>
                                            </StyledCell>
                                            <StyledCell className={classes.TableCellStyle1}>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                                                    <Chip
                                                        size="small"
                                                        label={statusLabel}
                                                        className={`${classes.statusChip} ${getRequestStatusChipClass(request)}`}
                                                    />
                                                    {statusLabel === 'Rejected' && (
                                                        <LightTooltip title={`Reason: ${request.rejectReason || 'Unknown'}${request.rejectComments ? ` — ${request.rejectComments}` : ''}`}>
                                                            <InfoOutlinedIcon fontSize="small" style={{ color: '#b71c1c' }} />
                                                        </LightTooltip>
                                                    )}
                                                    {statusLabel === 'Downloaded' && request.downloadReason && (
                                                        <LightTooltip title={`Reason: ${request.downloadReason}${request.downloadComments ? ` — ${request.downloadComments}` : ''}`}>
                                                            <InfoOutlinedIcon fontSize="small" style={{ color: '#4527a0' }} />
                                                        </LightTooltip>
                                                    )}
                                                    {statusLabel === 'Mailed' && request.mailedComments && (
                                                        <LightTooltip title={`Comments: ${request.mailedComments}`}>
                                                            <InfoOutlinedIcon fontSize="small" style={{ color: '#00695c' }} />
                                                        </LightTooltip>
                                                    )}
                                                    {statusLabel === 'Emailed' && request.emailedComments && (
                                                        <LightTooltip title={`Comments: ${request.emailedComments}`}>
                                                            <InfoOutlinedIcon fontSize="small" style={{ color: '#0d47a1' }} />
                                                        </LightTooltip>
                                                    )}
                                                </div>
                                            </StyledCell>
                                            <StyledCell className={classes.TableCellStyle1} align="center">
                                                {mailable ? (
                                                    <LightTooltip title="Mark as Mailed (sent manually, e.g. via Outlook)">
                                                        <IconButton
                                                            size="small"
                                                            aria-label="mark as mailed"
                                                            onClick={() => handleMailedClick(request)}
                                                            style={{ color: '#00695c' }}
                                                        >
                                                            <TaskAltOutlinedIcon fontSize="small" />
                                                        </IconButton>
                                                    </LightTooltip>
                                                ) : (
                                                    <span style={{ color: '#c7cdd4' }}>—</span>
                                                )}
                                            </StyledCell>
                                            <StyledCell className={classes.TableCellStyle1} style={{ whiteSpace: 'nowrap' }}>
                                                <div style={{ display: 'flex', flexWrap: 'nowrap', alignItems: 'center', gap: 2 }}>
                                                    <div style={{
                                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                        width: 30, height: 30, flexShrink: 0,
                                                    }}>
                                                        <div className={classes.viewIconScale}>
                                                            {request.letterType === 'PaidLetter' ?
                                                                <ViewPaidLetter dbtNumber={request?.debtorNumber} />
                                                                : request.letterType === 'CreditReportingNotMentionedLetter' ?
                                                                    <ViewCreditReportNotMentioned dbtNumber={request?.debtorNumber} />
                                                                    : request.letterType === 'CreditReportingNotAffectedLetter' ?
                                                                        <ViewCreditReportingNotAffected dbtNumber={request?.debtorNumber} />
                                                                        : request.letterType === 'CreditReportUpdated' ?
                                                                            <ViewCreditReportUpdated dbtNumber={request?.debtorNumber} />
                                                                            : null
                                                            }
                                                        </div>
                                                    </div>
                                                    <LightTooltip title="Download Letter">
                                                        <IconButton
                                                            size="small"
                                                            color="primary"
                                                            aria-label="download letter"
                                                            onClick={() => handleDownloadClick(request)}
                                                        >
                                                            <GetAppIcon fontSize="small" />
                                                        </IconButton>
                                                    </LightTooltip>
                                                    <LightTooltip title="View Audit History">
                                                        <IconButton
                                                            size="small"
                                                            aria-label="view audit history"
                                                            onClick={() => handleOpenAuditDrawer(request)}
                                                            style={{ color: '#3949ab' }}
                                                        >
                                                            <HistoryIcon fontSize="small" />
                                                        </IconButton>
                                                    </LightTooltip>
                                                    {emailable && (
                                                        <LightTooltip title="Mark as Emailed (sent outside WebView, e.g. via Outlook)">
                                                            <IconButton
                                                                size="small"
                                                                color="primary"
                                                                aria-label="mark as emailed"
                                                                onClick={() => handleEmailedClick(request)}
                                                            >
                                                                <EmailOutlinedIcon fontSize="small" />
                                                            </IconButton>
                                                        </LightTooltip>
                                                    )}
                                                    {actionable && (
                                                        <LightTooltip title="Reject Request">
                                                            <IconButton
                                                                size="small"
                                                                aria-label="reject request"
                                                                onClick={() => handleOpenRejectDrawer(request)}
                                                                style={{ color: '#b71c1c' }}
                                                            >
                                                                <BlockIcon fontSize="small" />
                                                            </IconButton>
                                                        </LightTooltip>
                                                    )}
                                                </div>
                                            </StyledCell>
                                        </StyledTableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                            {mapped ? (
                                <Typography variant="h6" gutterBottom style={{ color: 'red', marginTop: '10px' }}>
                                    No records to display..
                                </Typography>
                            ) : null}
                        </TableContainer>
                        <Grid container spacing={0}>
                            <Grid item xs={6} sm={7}>
                                <div className={classes.footer}>
                                    <Footer />
                                </div>
                            </Grid>
                            <Grid item xs={6} sm={4}>
                                <TablePagination
                                    rowsPerPageOptions={[15, 25, 50, 100]}
                                    component="div"
                                    count={totalRecords}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onChangePage={handleChangePage}
                                    onChangeRowsPerPage={handleChangeRowsPerPage}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <RejectRequestDrawer open={rejectDrawerOpen} request={rejectDrawerRequest} onClose={() => setRejectDrawerOpen(false)} onRejected={handleRejected} />
            <ViewAuditDrawer open={auditDrawerOpen} request={auditDrawerRequest} onClose={() => setAuditDrawerOpen(false)} />

            <Drawer open={!!downloadConfirmRequest} anchor="right" onClose={() => setDownloadConfirmRequest(null)}>
                <Box
                    display="flex"
                    flexDirection="column"
                    style={{
                        height: '100%',
                        width: 480,
                        maxWidth: '95vw',
                        fontFamily: "'Roboto', 'Helvetica Neue', Arial, sans-serif",
                    }}
                >
                    <Box
                        style={{
                            position: 'relative',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: '#007FFF',
                            color: '#fff',
                            height: 40,
                            flexShrink: 0,
                        }}
                    >
                        <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
                            Download Letter
                        </Typography>
                        <IconButton
                            aria-label="close"
                            onClick={() => setDownloadConfirmRequest(null)}
                            style={{ position: 'absolute', right: 3, top: 1, color: 'white', padding: '4px' }}
                        >
                            <HighlightOffIcon style={{ fontSize: 30 }} />
                        </IconButton>
                    </Box>

                    <Box flexGrow={1} style={{ padding: 16, overflow: 'hidden' }}>
                        <Grid container spacing={2}>
                            {downloadConfirmRequest && (
                                <Grid item xs={12}>
                                    <Box display="flex" alignItems="center" style={{ gap: 8 }}>
                                        <DescriptionOutlinedIcon fontSize="small" color="action" />
                                        <Box>
                                            <Typography variant="body2" style={{ fontWeight: 600 }}>
                                                {downloadConfirmRequest.letterName}
                                            </Typography>
                                            <Typography variant="caption" color="textSecondary">
                                                Debtor {downloadConfirmRequest.debtorNumber}
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Grid>
                            )}

                            <Grid item xs={12}>
                                <Typography variant="body2" color="textSecondary">
                                    This will be recorded in the request's audit history.
                                </Typography>
                            </Grid>

                            <Grid item xs={12}>
                                <FormControl variant="outlined" size="small" fullWidth required>
                                    <InputLabel shrink>Download Reason</InputLabel>
                                    <Select
                                        label="Download Reason"
                                        displayEmpty
                                        value={downloadReason}
                                        onChange={(e: any) => setDownloadReason(e.target.value)}
                                        MenuProps={{ anchorOrigin: { vertical: 'bottom', horizontal: 'left' }, getContentAnchorEl: null }}
                                    >
                                        <MenuItem value="" disabled>Select a reason</MenuItem>
                                        {downloadReasons.map((r) => (
                                            <MenuItem key={r.downloadReasonId} value={r.downloadReason}>{r.downloadReason}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                {downloadReason && downloadReasonHelp[downloadReason] && (
                                    <Typography variant="caption" color="textSecondary" display="block" style={{ marginTop: 4 }}>
                                        {downloadReasonHelp[downloadReason]}
                                    </Typography>
                                )}
                            </Grid>

                            <Grid item xs={12}>
                                <textarea
                                    value={downloadComments}
                                    onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setDownloadComments(e.target.value)}
                                    placeholder={downloadCommentsRequired ? 'Required when reason is Other' : 'Optional — recorded for the audit trail'}
                                    maxLength={1000}
                                    style={{
                                        width: '100%', boxSizing: 'border-box', minHeight: 90,
                                        fontFamily: 'inherit', fontSize: '0.9rem', padding: '8px 10px',
                                        border: downloadCommentsRequired && !downloadComments.trim() ? '1px solid #f44336' : '1px solid rgba(0, 0, 0, 0.23)',
                                        borderRadius: 4,
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </Box>

                    <Box
                        display="flex"
                        style={{ gap: 12, padding: 16, borderTop: '1px solid rgba(0, 0, 0, 0.12)', flexShrink: 0 }}
                    >
                        <Button
                            variant="contained"
                            color="primary"
                            fullWidth
                            disabled={!isDownloadConfirmValid}
                            onClick={handleConfirmDownload}
                        >
                            Download
                        </Button>
                        <Button
                            variant="contained"
                            fullWidth
                            onClick={() => setDownloadConfirmRequest(null)}
                        >
                            Cancel
                        </Button>
                    </Box>
                </Box>
            </Drawer>

            <Drawer open={!!mailedConfirmRequest} anchor="right" onClose={() => setMailedConfirmRequest(null)}>
                <Box
                    display="flex"
                    flexDirection="column"
                    style={{
                        height: '100%',
                        width: 480,
                        maxWidth: '95vw',
                        fontFamily: "'Roboto', 'Helvetica Neue', Arial, sans-serif",
                    }}
                >
                    <Box
                        style={{
                            position: 'relative',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: '#007FFF',
                            color: '#fff',
                            height: 40,
                            flexShrink: 0,
                        }}
                    >
                        <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
                            Mark as Mailed
                        </Typography>
                        <IconButton
                            aria-label="close"
                            onClick={() => setMailedConfirmRequest(null)}
                            style={{ position: 'absolute', right: 3, top: 1, color: 'white', padding: '4px' }}
                        >
                            <HighlightOffIcon style={{ fontSize: 30 }} />
                        </IconButton>
                    </Box>

                    <Box flexGrow={1} style={{ padding: 16, overflow: 'hidden' }}>
                        <Grid container spacing={2}>
                            {mailedConfirmRequest && (
                                <Grid item xs={12}>
                                    <Box display="flex" alignItems="center" style={{ gap: 8 }}>
                                        <TaskAltOutlinedIcon fontSize="small" color="action" />
                                        <Box>
                                            <Typography variant="body2" style={{ fontWeight: 600 }}>
                                                {mailedConfirmRequest.letterName}
                                            </Typography>
                                            <Typography variant="caption" color="textSecondary">
                                                Debtor {mailedConfirmRequest.debtorNumber}
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Grid>
                            )}

                            <Grid item xs={12}>
                                <Typography variant="body2" color="textSecondary">
                                    Use this option when the letter has been physically mailed to the
                                    requester through USPS. This does not send the letter from WebView;
                                    it only records that the letter has been mailed in the request's
                                    audit history.
                                </Typography>
                            </Grid>

                            <Grid item xs={12}>
                                <Typography variant="caption" color="textSecondary" display="block" style={{ marginBottom: 4 }}>
                                    Comments (optional)
                                </Typography>
                                <textarea
                                    value={mailedComments}
                                    onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setMailedComments(e.target.value)}
                                    placeholder="e.g. Mailed via USPS on 10/05"
                                    maxLength={1000}
                                    style={{
                                        width: '100%', boxSizing: 'border-box', minHeight: 90,
                                        fontFamily: 'inherit', fontSize: '0.9rem', padding: '8px 10px',
                                        border: '1px solid rgba(0, 0, 0, 0.23)',
                                        borderRadius: 4,
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </Box>

                    <Box
                        display="flex"
                        style={{ gap: 12, padding: 16, borderTop: '1px solid rgba(0, 0, 0, 0.12)', flexShrink: 0 }}
                    >
                        <Button
                            variant="contained"
                            style={{ backgroundColor: '#00695c', color: '#fff' }}
                            fullWidth
                            disabled={markingMailed}
                            onClick={handleConfirmMailed}
                        >
                            {markingMailed ? 'Saving...' : 'Confirm Mailed'}
                        </Button>
                        <Button
                            variant="contained"
                            fullWidth
                            disabled={markingMailed}
                            onClick={() => setMailedConfirmRequest(null)}
                        >
                            Cancel
                        </Button>
                    </Box>
                </Box>
            </Drawer>

            <Drawer open={!!emailedConfirmRequest} anchor="right" onClose={() => setEmailedConfirmRequest(null)}>
                <Box
                    display="flex"
                    flexDirection="column"
                    style={{
                        height: '100%',
                        width: 480,
                        maxWidth: '95vw',
                        fontFamily: "'Roboto', 'Helvetica Neue', Arial, sans-serif",
                    }}
                >
                    <Box
                        style={{
                            position: 'relative',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: '#007FFF',
                            color: '#fff',
                            height: 40,
                            flexShrink: 0,
                        }}
                    >
                        <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
                            Mark as Emailed
                        </Typography>
                        <IconButton
                            aria-label="close"
                            onClick={() => setEmailedConfirmRequest(null)}
                            style={{ position: 'absolute', right: 3, top: 1, color: 'white', padding: '4px' }}
                        >
                            <HighlightOffIcon style={{ fontSize: 30 }} />
                        </IconButton>
                    </Box>

                    <Box flexGrow={1} style={{ padding: 16, overflow: 'hidden' }}>
                        <Grid container spacing={2}>
                            {emailedConfirmRequest && (
                                <Grid item xs={12}>
                                    <Box display="flex" alignItems="center" style={{ gap: 8 }}>
                                        <EmailOutlinedIcon fontSize="small" color="action" />
                                        <Box>
                                            <Typography variant="body2" style={{ fontWeight: 600 }}>
                                                {emailedConfirmRequest.letterName}
                                            </Typography>
                                            <Typography variant="caption" color="textSecondary">
                                                Debtor {emailedConfirmRequest.debtorNumber}
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Grid>
                            )}

                            <Grid item xs={12}>
                                <Typography variant="body2" color="textSecondary">
                                    Use this option after the letter has been emailed to the requester
                                    outside of WebView, such as through Outlook. This does not send an
                                    email from WebView; it only records the email activity in the
                                    request's audit history.
                                </Typography>
                            </Grid>

                            <Grid item xs={12}>
                                <Typography variant="caption" color="textSecondary" display="block" style={{ marginBottom: 4 }}>
                                    Comments (optional)
                                </Typography>
                                <textarea
                                    value={emailedComments}
                                    onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setEmailedComments(e.target.value)}
                                    placeholder="e.g. Sent via Outlook on 10/05"
                                    maxLength={1000}
                                    style={{
                                        width: '100%', boxSizing: 'border-box', minHeight: 90,
                                        fontFamily: 'inherit', fontSize: '0.9rem', padding: '8px 10px',
                                        border: '1px solid rgba(0, 0, 0, 0.23)',
                                        borderRadius: 4,
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </Box>

                    <Box
                        display="flex"
                        style={{ gap: 12, padding: 16, borderTop: '1px solid rgba(0, 0, 0, 0.12)', flexShrink: 0 }}
                    >
                        <Button
                            variant="contained"
                            color="primary"
                            fullWidth
                            disabled={markingEmailed}
                            onClick={handleConfirmEmailed}
                        >
                            {markingEmailed ? 'Saving...' : 'Confirm Emailed'}
                        </Button>
                        <Button
                            variant="contained"
                            fullWidth
                            disabled={markingEmailed}
                            onClick={() => setEmailedConfirmRequest(null)}
                        >
                            Cancel
                        </Button>
                    </Box>
                </Box>
            </Drawer>
        </React.Fragment>
    );
};

export default ClosedLetterRequests;
